module.exports = __webpack_public_path__ + "img/hr-puberty-decal-24.4788724d.png";